import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import $ from "jquery";
import axiosInstance from "../../services/api";
import "datatables.net";
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt";
import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import Select from "react-select";
import Loader from '../Commons/Loader';
function ReportVerification() {
    const tableRef = useRef(null);
    const [reportListData, setReportListData] = useState([]);
    const startDatepickerRef = useRef(null);
    const endDatepickerRef = useRef(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [hotelId, setHotelId] = useState("");
    const [hotelListData, setHotelListData] = useState([]);
    const [placeholder, setPlaceholder] = useState("Please Select Hotel Id");
    const [loading, setLoading] = useState(true);
     const [errorMessage, setErrorMessage] = useState(""); 
    const [onChangeKey, setOnChangeKey] = useState("false");
    
    // Fetch hotel data
    const fetchDataHotel = async () => {
        try {
            const response = await axiosInstance.get('hotel/all-hotels.json');
            setHotelListData(response.data.data || []);
        } catch (error) {
            console.error('Error fetching hotel data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        fetchDataHotel();
    }, []);

    // Initialize datepickers
    useEffect(() => {
        const today = new Date();

        $(startDatepickerRef.current).datepicker({
            dateFormat: "yy-mm-dd",
            maxDate: today,
            onSelect: (selectedDate) => {
                $(endDatepickerRef.current).datepicker("option", "minDate", selectedDate);
                setStartDate(selectedDate);
            },
        });

        $(endDatepickerRef.current).datepicker({
            dateFormat: "yy-mm-dd",
            maxDate: today,
            onSelect: (selectedDate) => {
                $(startDatepickerRef.current).datepicker("option", "maxDate", selectedDate);
                setEndDate(selectedDate);
            },
        });
    }, []);

    const options = hotelListData.map((item) => ({
        value: item.id,
        label: item.hotelName,
    }));

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "40px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    const handleSelectChange = (e) => {
        setHotelId(e.value);
        setOnChangeKey("true");
    };

    // Initialize or reinitialize DataTable
    const initializeDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            data: reportListData.map((item) => [
                item.hotelId,
                item.hotelName,
                item.reportDate,
                item.status,
                item.missingReports,
            ]),
            columns: [
                { title: "Hotel Id" },
                { title: "Hotel Name" },
                { title: "Report Date" },
                { title: "Status" },
                { title: "Missing Reports" },
            ],
            paging: true,
            searching: true,
            lengthChange: true,
            ordering: true,
            responsive: {
                   
            },
            columnDefs: [
                { targets: 1, responsivePriority: 1 }, // Name - Always visible
                { targets: 2, responsivePriority: 2 }, // Operations - Always visible
                { targets: [1, 2, 3], responsivePriority: 2 } 
                
            ],
        });
    };

    // Reinitialize DataTable when reportListData changes
    useEffect(() => {
        if (reportListData.length > 0) {
            initializeDataTable();
        }
    }, [reportListData]);
    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axiosInstance.get(
                `report/process-details?hotelId=${hotelId}&startDate=${startDate}&endDate=${endDate}`
            );
            if (response.status === 200) {
                if(response.data.status.code===200) {

                }else{
                    setErrorMessage(response.data.message)
                }
            }
            const data = response.data.data || [];
            setReportListData(data);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
    };
    console.log(startDate,endDate,hotelId)
    const isDisabled = onChangeKey==="false" || !startDate || !endDate || hotelId==="" ;
    return (
        <>
            {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Report Verification</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Report Verification</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <div className='usage-report-section'>
                        <div className='usage-report-top'>
                            <div className='row'>
                                <div className="col-lg-3 mb-mob">
                                    <Select
                                        options={options}
                                        onChange={handleSelectChange}
                                        placeholder={placeholder}
                                        styles={customStyles}
                                        
                                        isSearchable
                                        noOptionsMessage={() => "No sub-hotels available"}
                                    />
                                </div>
                                <div className="col-lg-3 mb-mob">
                                    <input
                                        type="text"
                                        placeholder="Start Date"
                                        className="input-fld"
                                        ref={startDatepickerRef}
                                        onKeyDown={(e) => {
                                            if (e.key === "Backspace") {
                                                e.preventDefault(); // Disable backspace functionality
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3 mb-mob">
                                    <input
                                        type="text"
                                        placeholder="End Date"
                                        className="input-fld"
                                        ref={endDatepickerRef}
                                        onKeyDown={(e) => {
                                            if (e.key === "Backspace") {
                                                e.preventDefault(); // Disable backspace functionality
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-2">
                                    <button
                                        onClick={handleSubmit}
                                        className="btn btn-primary submit-btn search-btn"
                                        disabled={isDisabled}
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                            <table
                                ref={tableRef}
                                className="display styled-table report-verification-table"
                            ></table>
                            {errorMessage && <p className="error-msg" style={{ color: 'red' }}>{errorMessage}</p>}
                    </div>
                </div>
            </section>
        </>
    );
}

export default ReportVerification;
